export const COOKIE_WARNING_DATA = {
  key: 'yc_2',
  text: 'SHARED_COOKIE_LAYER_MESSAGE',
  policyText: 'SHARED_COOKIE_LAYER_POLICY',
  url: '/condiciones-de-uso/#cookies'
}

export const COOKIE_CMP = 'euconsent-v2'

export const COOKIE_SMARTBANNER = 'smartbanner'

export const COOKIE_PREFIX_DISCARDED_ADS = 'DiscardedAds_'
export const COOKIE_DISCARDED_ADS_EXPIRATION = 180
